import React, { useEffect, useState } from "react";
import Button from "../Button/Button";
import NextIcon from "../SvgIcons/CommonIcons/NextIcon";
import PreviousIcon from "../SvgIcons/CommonIcons/PreviousIcon";
import TileList from "../Tile/TileList/TileList";
import Input from "../ReactForm/Input/Input";
import classes from "./MainLayout.module.scss";
import { useLocation, useNavigate, useOutletContext } from "react-router";
import ToggleButton from "../ToggleButton/ToggleButton";
import { organizationSettings } from "../../../utils/mainTabs/admin/organizationSettings/organizationSettings";

const MainLayout = ({
  heading,
  navLinks,
  buttons,
  tiles,
  tileType,
  tileSize,
  children,
  isStepTile,
  radio,
  toggleOn = false,
  isReportBtn,
  handleReportNavigation,
  isRadioBtn = false,
  isOrganiseSettingText = "",
  isOrTextPresent = false,
}) => {
  const primaryColor = JSON.parse(localStorage.getItem("themeData"))?.CustomData
    ?.PrimaryColor1;
  const location = useLocation();
  const { tenantName } = useOutletContext();

  return (
    <div className={classes.mainLayout}>
      <div className={classes.mainLayout__stickySection}>
        <div className={classes.mainLayout__stickySection__header}>
          {heading ? (
            <div className={classes.mainLayout__stickySection__header__heading}>
              {heading}
            </div>
          ) : navLinks ? (
            <div
              className={classes.mainLayout__stickySection__header__navLinks}
            >
              {navLinks.map((navLink, index, navArr) => {
                return (
                  <div
                    key={navLink?.key}
                    className={
                      classes.mainLayout__stickySection__header__navLinks__link
                    }
                    style={{
                      color: `${
                        navArr.length - 1 === index ? "#404040" : primaryColor
                      }`,
                      textDecoration: `${
                        navArr.length - 1 === index ? "none" : "underline"
                      }`,
                    }}
                  >
                    {index === 0 ? (
                      <PreviousIcon fill={primaryColor} />
                    ) : (
                      <NextIcon />
                    )}
                    <div
                      className={
                        classes.mainLayout__stickySection__header__navLinks__link__text
                      }
                      onClick={navLink.onClick}
                    >
                      {navLink.label}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <></>
          )}
          <div
            className={classes.mainLayout__stickySection__header__buttonsList}
          >
            <div className={classes.radioButton_Heading}>
              {isRadioBtn &&
                (location.pathname ===
                  `/${localStorage.getItem(
                    "tenantName"
                  )}/reports/tabularReport/userTabularReport` ||
                  location.pathname ===
                    `/${localStorage.getItem(
                      "tenantName"
                    )}/reports/tabularReport/tabularAdvanceReport`) && (
                  <div>
                    <div
                      style={{
                        fontSize: 1.5 + "rem",
                        color: "#404040",
                        fontWeight: "bold",
                        marginBottom: 0.2 + "px",
                      }}
                    >
                      Show Advanced Report
                    </div>
                    <ToggleButton
                      enable={toggleOn}
                      handleClick={handleReportNavigation}
                    />
                  </div>
                )}
            </div>
            {isOrganiseSettingText &&
              localStorage.getItem("SecurityProviderName") === "aad" &&
              location.pathname.includes(
                organizationSettings.path(tenantName)
              ) && <>{isOrganiseSettingText}</>}
            {buttons?.map((button) => {
              return (
                <Button
                  width={button?.width}
                  key={button.key}
                  label={button?.label}
                  onClick={button?.onClick}
                  icon={button?.icon}
                  color={button?.color}
                  isHover
                  isReportBtn
                  path={button?.path}
                  loading={button?.loading}
                  name={button?.name}
                  feature={button?.feature}
                />
              );
            })}
          </div>
        </div>
        {tiles?.length > 0 ? (
          <div className={classes.mainLayout__stickySection__tilesList}>
            <TileList
              data={tiles}
              type={tileType}
              size={tileSize}
              isStepTile={isStepTile}
              isOrTextPresent={isOrTextPresent}
            />
          </div>
        ) : (
          <></>
        )}
        <div>{children}</div>
      </div>
    </div>
  );
};

export default MainLayout;
